import { compose, path, prop, values } from 'ramda';

import { getEntireForm } from '@gef-ui/redux-common/selectors/entireForm';

const formSelectorsFactory = (name) => {
	const getForm = (state) => state[name];
	const getIsFormEmpty = (formData) => !values(formData).join('').length > 0;

	return {
		getGlobalErrors: compose(prop('globalErrors'), getForm),
		getFormData: compose(prop('formData'), getForm),
		getStatus: compose(prop('status'), getForm),
		getIsPristine: compose(path(['status', 'pristine']), getForm),
		getIsEmpty: compose(getIsFormEmpty, prop('formData'), getForm),
		getEntireForm: getEntireForm(name),
	};
};

export default formSelectorsFactory;
